import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {
  startDate: null,
  endDate: null
};

const PollsReducer = (state = initialState, { type, payload } = {}) => {
  if (type === ACTION_TYPES.SET_POLLS_START_END_DATE) {
    return {
      ...state,
      startDate: payload?.startDate,
      endDate: payload?.endDate
    };
  }
  return state;
};

export default PollsReducer;
